import { useState, useEffect, useRef, DragEventHandler } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { AdminService } from "../../../../services/AdminService";
import { CommonService } from "../../../../services/CommonService";
import { closelightbox } from "../../../../util/Functions";

export const useSignatureAdmin = (open: boolean, data: any, changeAlert: ChangeAlertCallbackType) => {
	const adminService = useRef<AdminService>();
	const commonService = useRef<CommonService>();
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [isValidSearch, setIsValidSearch] = useState<boolean>(true);
    const [currentAgent, setCurrentAgent] = useState({});
    const [form, setForm] = useState({});
    const [search, setSearch] = useState("");
    const [newSign, setNewSign] = useState(false);
    const [zPos, setZPos] = useState(45);
    const [loading, setLoading] = useState(false);
    const dropZoneRef = useRef<null | HTMLDivElement>(null);
	

    const onConfirm = async (item) => {
		if (data) {
			let payload = {
				uuid: data.uuid,
				body: {
					authSignature: false
				}
			}
			await onHandleUpdateAgent(payload);
		}
		let payload = {
			uuid: item.uuid,
			body: {
				authSignature: true
			}
		}
		await onHandleUpdateAgent(payload);

		let payloadFile = {
			file: item["signature"].split(",")[1],
			path: `signature/${item['uuid']}.png`
		}
		await onHandleUpdateFile(payloadFile);
    };

	const onClose = () => {
		onHandleReset();
        closelightbox();
	}

	const onHandleUpdateFile = async (request) => {
        setLoading(true);
        setZPos(-1);

        const response = await commonService.current.uploadBucketFile(request);
        if (response["data"]?.response === "OK") {
			changeAlert(true, "success", "El documento se cargó con éxito");
			onClose();
        } else {
			changeAlert(true, "error", response["message"] || response["data"]['message'] || "Error al insertar documento");
			setZPos(45);
			setLoading(false);
        };

	};

	const onHandleUpdateAgent = async (request) => {
        setLoading(true);
        setZPos(-1);

        const response = await adminService.current.updateAgent(request);
        if (response["data"]?.response === "OK") {
			changeAlert(true, "success", "El agente fue actualizado con éxito");
        } else {
            changeAlert(true, "error", response["message"] || response["data"]['message'] || "Error al consultar servicio");
        };

        setZPos(45);
        setLoading(false);
	};

	const onHandleSearch = async () => {
        setLoading(true);
        setZPos(-1);

        const response = await adminService.current.agentByEmail(search);
        if (response["data"]?.response === "OK") {
			let content = response["data"]["content"];
			if (content["signature"]) {
				content["signature"] = `data:image/png;base64,${content["signature"]}`
			}
			setForm(JSON.parse(JSON.stringify(content)));
			validateForm(JSON.parse(JSON.stringify(content)));
			!response["data"]["content"]["uuid"] && changeAlert(true, "error", "El email no existe o se encuentra inactivo en la base de datos");
        } else {
            changeAlert(true, "error", response["message"] || response["data"]['message'] || "Error al consultar servicio");
        };

        setZPos(45);
        setLoading(false);
    };

    const onHandleChange = (e) => {
        let value = e.target.value.trim();
        setSearch(JSON.parse(JSON.stringify(value)));
        validateSearch(JSON.parse(JSON.stringify(value)));
    };

	const validateSearch = (s) => {
    	s ? setIsValidSearch(false) : setIsValidSearch(true);
    };

    const validateForm = (f) => {
        if (f["signature"] && f["uuid"]) {
            setIsValidForm(false);
        } else {
            setIsValidForm(true);
        }
    };

    const onHnadleNewSign = () => {
		!newSign && setIsValidForm(true);
        newSign ? setNewSign(false) : setNewSign(true);
    };

	const parseJson = (selectedFile) => {
        setLoading(true);
        setZPos(-1);

		const reader = new FileReader();
        let f = form;

		reader.readAsDataURL(selectedFile);

		reader.onload = () => {
			f["signature"] = reader.result;
			f["signature"] && setIsValidForm(false);
			setForm(JSON.parse(JSON.stringify(f)));
		};

		setNewSign(false);
        setLoading(false);
        setZPos(45);
    };

	const onSelectFile = (e) => {
        let img = e.target.files[0];
        let extension = (name) => {
            return ["png", "jpg", "jpeg"].indexOf(name.split('.').pop()) === -1 ? true : false;
        }

        if (!img) {
            changeAlert(true, "error", "Error en selección de archivo");
        } else if (extension(img.name)) {
            changeAlert(true, "error", "Error: El tipo de archivo no es permitido.");
        } else {
            parseJson(img);
        }
    };

	const handleOver: DragEventHandler<HTMLDivElement> = (event) => {
		event.preventDefault();
		event.stopPropagation();
		if (dropZoneRef.current) {
			dropZoneRef.current.style.borderColor = "#1890ff";
			dropZoneRef.current.style.borderWidth = "2px";
			dropZoneRef.current.style.backgroundColor = "rgba(119, 119, 255,0.1)";
		}
	};

	const handleLeave: DragEventHandler<HTMLDivElement> = (event) => {
		event.preventDefault();
		event.stopPropagation();
		if (dropZoneRef.current) {
			dropZoneRef.current.style.borderColor = "lightgray";
			dropZoneRef.current.style.borderWidth = "1px";
			dropZoneRef.current.style.backgroundColor = "transparent";
		}
	};

	const handleDrop: DragEventHandler<HTMLDivElement> = (event) => {
		event.preventDefault();
		event.stopPropagation();

		if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
			const filesToUpload = [];
			for (let i = 0; i < event.dataTransfer.files.length; i++) {
				filesToUpload.push(event.dataTransfer.files.item(i));
			}

			if (filesToUpload.length > 0) {
				parseJson(filesToUpload[0]);
				handleLeave(event);
			}
			event.dataTransfer.clearData();
		}
	};

	const onHandleReset = () => {
		setCurrentAgent(JSON.parse(JSON.stringify({})));
		setIsValidForm(true);
		setIsValidSearch(true);
		setForm({});
		setSearch("");
		setZPos(45);
		setLoading(false);
	}

    useEffect(() => {
        if (open && data) {
            setCurrentAgent(JSON.parse(JSON.stringify(data)));
        }
        if (!open) {
            onHandleReset();
		}
        adminService.current = new AdminService(changeAlert);
        commonService.current = new CommonService(changeAlert);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

	return {
        zPos,
        form,
        loading,
        currentAgent,
        search,
        isValidSearch,
        isValidForm,
        dropZoneRef,
		newSign,
        onHandleChange,
        onHandleSearch,
        onConfirm,
		onSelectFile,
        handleOver,
        handleLeave,
        handleDrop,
		onHnadleNewSign,
		onClose
    };
};
